export const PRIMARY_BUSTLY_WEB_ORIGIN = 'https://www.bustly.ai';
export const TEST_BUSTLY_WEB_ORIGIN = 'https://test-www.bustly.ai';

const LEGACY_BUSTLY_WEB_ORIGINS = new Map([
    ['bustly.shop', PRIMARY_BUSTLY_WEB_ORIGIN],
    ['www.bustly.shop', PRIMARY_BUSTLY_WEB_ORIGIN],
    ['test-www.bustly.shop', TEST_BUSTLY_WEB_ORIGIN],
]);

const ACTIVE_BUSTLY_WEB_ORIGINS = new Set([
    PRIMARY_BUSTLY_WEB_ORIGIN,
    TEST_BUSTLY_WEB_ORIGIN,
]);

const isSafeRelativeRedirect = (value: string): boolean => (
    value.startsWith('/') && !value.startsWith('//')
);

const currentWebOrigin = (): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return new URL(window.location.origin).origin;
    } catch {
        return null;
    }
};

export const resolveBustlyWebRedirect = (
    redirect: string | null | undefined,
    fallback = '/admin',
): string => {
    let decoded = redirect || fallback;
    try {
        decoded = decodeURIComponent(decoded);
    } catch {
        decoded = fallback;
    }

    decoded = decoded.trim();
    if (!decoded || /[\u0000-\u001f\u007f]/.test(decoded)) {
        return fallback;
    }
    if (isSafeRelativeRedirect(decoded)) {
        return decoded;
    }

    try {
        const url = new URL(decoded);
        if (
            url.username
            || url.password
            || (url.protocol !== 'https:' && url.protocol !== 'http:')
        ) {
            return fallback;
        }

        const legacyTargetOrigin = LEGACY_BUSTLY_WEB_ORIGINS.get(
            url.hostname.toLowerCase().replace(/\.$/, ''),
        );
        if (legacyTargetOrigin) {
            const targetOrigin = new URL(legacyTargetOrigin);
            url.protocol = targetOrigin.protocol;
            url.hostname = targetOrigin.hostname;
            url.port = '';
            return url.toString();
        }

        const allowedOrigins = new Set(ACTIVE_BUSTLY_WEB_ORIGINS);
        const activeOrigin = currentWebOrigin();
        if (activeOrigin) {
            allowedOrigins.add(activeOrigin);
        }
        if (!allowedOrigins.has(url.origin)) {
            return fallback;
        }

        // Preserve the exact active origin, including non-default local development ports.
        return url.toString();
    } catch {
        return fallback;
    }
};
